export default __webpack_public_path__ + "static/media/prime-eva.ad187321.jpg";